// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__21DtU","right":"Footer_right__19ckW","buttons":"Footer_buttons__1agd4"};